import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FaPhoneVolume } from 'react-icons/fa';
import { MdLocationOn, MdOutlineEmail } from 'react-icons/md';
import { Button, Col, Row } from 'react-bootstrap';
import CenterStage from '../../Components/CenterStage/CenterStage';
import SectionHeader from '../../Components/SectionHeader/SectionHeader';
import FeatureCardCarousel from '../../Components/FeaturesCardCarousal/FeatureCardCarousal';
import ShowcaseCarousel from '../../Components/ShowcaseCarousel/ShowcaseCarousel';
import FullImageText from '../../Components/FullImageText/FullImageText';

import imgStage from '../../assets/WhoWeAre/stage.jpg';
import imgService from '../../assets/WhoWeAre/service.jpg';
import hose from '../../assets/HoseLogo.png';
import imgCartons from '../../assets/Hansa-Flex_Kartons_Shop.png';
import imgVan from '../../assets/WhoWeAre/service van.jpg';
// import imgVan from '../../assets/brandImages/Services_MHS_Kanalseite_01.jpg';
import imgLogistics from '../../assets/LogisticsImg.jpg';
import imgCustomerSupport from '../../assets/customer-support.png';
import imgHose from '../../assets/WhoWeAre/Hose.jpg';
import ImageText from '../../Components/ImageText/ImageText';
import imgVannew from '../../assets/WhoWeAre/Vannew.jpg';
import NumberGrid from '../../Components/NumberGrid/NumberGrid';

function WhoWeAre() {
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    const { t } = useTranslation();

    // features card carousel data
    const featuresData = [
        {
            title: "Customer support",
            description: "Offering expert advice and assistance to our customers in Brazil.",
            image: imgCustomerSupport
        },
        {
            title: "Extensive stock availability",
            description: "We have stocks of products around 13000 units!",
            image: imgCartons
        },
        {
            title: "Premium quality hoses",
            description: "Experience our unmached Quality",
            image: hose
        }
        // Add more objects for additional FeaturesCard data
    ];


    const numbers = ['+460', '+5150', '3', '41'];
    const subtitles = ["units", "collaborators", "ISO 9001, 14001 and 45001", "countries present"];

    const carouselItems = [
        {
            imgSrc: imgService,
            title: 'Easy-Order Easy-Delivery',
            description: 'At HANSA-FLEX Brazil we provide best of customer service and take care that the quality product is delivered.'
        },

        {
            imgSrc: imgLogistics,
            title: 'We Make it, We deliver it',
            description: 'HANSA-FLEX Brazil ensures hoses and fittings are consistently stocked, guaranteeing uninterrupted operations for clients. With a proactive approach, we prioritize maintaining ample inventory, delivering reliability and efficiency to meet diverse hydraulic system needs.'
        }
    ];

    const Pumps = () => { }
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    const pump1 = {
        image: imgVan,
        title: 'The principle of success is called the partnership system',
        description: '',
        listItems: ["It is the range and quality of products and services that make the company a valuable partner.", "In a key technology such as hydraulics, the customer has a preference for solutions from a single source.", "The extensive network of subsidiaries opens the door to the world of hydraulic services from HANSA-FLEX."],
        buttonName: "ALL GEAR PUMPS"
    };

    const pump2 = {
        image: imgHose,
        title: "Our customers' machines, factories and systems must always work",
        description: 'Safe, reliable and uninterrupted. Wherever you need it. Our MHS mobile units and our branches are available. In addition, the safety of people and the environment is part of the HANSA-FLEX commitment to our customers, we are constantly improving the technology of our products, to maintain the exceptional quality of our work.',
        // listItems: [""],
        buttonName: "ALL AXIAL PISTON PUMPS"
    }
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    return (
        <div>
            <CenterStage imageSrc={imgStage} title={"Welcome to HANSA-FLEX Brazil"} paragraph={"The importance of fluid technology is growing worldwide and with it the expectations of HANSA-FLEX customers in all segments of the economy. Today, HANSA-FLEX is Europe's leading supplier of hydraulic hoses and components and a great partner for high-performance companies of all sizes. We focus on international growth while expanding our product range. We will continue on our path to become one of the world's leading suppliers of hoses and hydraulic components. An important step in the future is the focus on the Middle East and Asian markets."} />

            <FullImageText
                imageSrc={imgVannew}
                altText="Service Mobile Van"
                title="Your Hydraulic Solutions on Wheels"
                paragraph="Our service mobile van is equipped with the latest tools and technology to provide on-site hydraulic solutions. Whether it's urgent repairs or routine maintenance, our expert team is ready to deliver exceptional service directly to your location, ensuring minimal downtime and maximum efficiency."
                imageWidth={1}
            />

            <ImageText data={pump1} />
            <ImageText data={pump2} left={false} />

            {/* <div>
                {isLaptop && (
                    <Promoter
                        title={promoterTitle}
                        checklistItems={promoterChecklistItems}
                        btnLabel1={"Find Out More !"}
                        imageUrl={imgTeams}
                    />
                )}
            </div> */}

            <div className='div-gray'>
                <SectionHeader title={"Why choose us?"} paragraph={"We are the epitome of excellence, renowned for our unwavering commitment to quality and customer satisfaction. We provide unrivaled solutions tailored to your needs."} />
                <FeatureCardCarousel featuresData={featuresData} />
            </div>

            <div className='div-gray center-all-items'>
                <SectionHeader
                    title={"HANSA-FLEX in figures"}
                    paragraph={"HANSA-FLEX is one of the world's leading system suppliers for all fields of hydraulics."} /><br />
                <NumberGrid numbers={numbers} subtitles={subtitles} />
            </div>
            
            <br /><br />
            <ShowcaseCarousel carouselItems={carouselItems} isExploreButton={false} descDisplay='block' carouselType={1} />
            <br /><br />

            <div className="text-center div-gray">
                <SectionHeader title={"Explore about HANSA-FLEX Group"}
                    paragraph={"HANSA-FLEX is a global family-run company and one of the world’s leading system partners for fluid technology. In the last business year, more than 5,000 employees in 40 countries achieved a turnover of EUR 570 million."} />
                <br />
                <Button variant="danger" href={"https://www.hansa-flex.de/en/company/"} target="_blank" style={{ boxShadow: '10px 10px 20px rgba(0, 0, 0, 0.2)' }}>{t("Learn more about HANSA-FLEX")}</Button>
                <br /><br /><br />
            </div>

            {/* <div style={{ backgroundColor: '#30557d', padding: '20px', color: 'white', paddingLeft: '10%' }}>
                <Row>
                    <Col xs={12} md={6}>
                        <h2>{t("Contact details")}:</h2>
                        <p>{t("For further information, assistance or collaboration, please do not hesitate to contact us")}:</p>
                        <p> <MdLocationOn /> {t("Address")}: <a href="https://maps.app.goo.gl/BshYURN7US8emDfy8" style={{ textDecoration: 'none', color: 'white' }} > HANSA-FLEX Brazil Ltd., Highway BR-470, 2461 - Itoupavazinha, Blumenau - SC, 89066-010, Brazil</a></p>
                        <p> <MdOutlineEmail /> {t("Email")}: <a href="mailto:bbl@hansa-flex.com" style={{ textDecoration: 'none', color: 'white' }}>     bbl@hansa-flex.com</a></p>
                        <p> <FaPhoneVolume /> {t("Phone")}: <a href="tel:+55 47 3321 6300" style={{ textDecoration: 'none', color: 'white' }} >     +55 47 3321 6300</a></p>
                    </Col>
                </Row>
            </div> */}
        </div>
    );
};

export default WhoWeAre